import React, { Component } from 'react'
import { connect } from 'react-redux'
import withStyles from 'isomorphic-style-loader/withStyles';
import { Field, reduxForm, formValueSelector } from 'redux-form';
import s from './ManageServiceFee.css'

import {
    Row,
    FormGroup,
    Col,
    Form,
    InputGroup,
    Container,
    OverlayTrigger,
    Popover
} from 'react-bootstrap';
import cx from 'classnames';
import { injectIntl, FormattedMessage } from 'react-intl';
import messages from '../../../locale/messages'
import Loader from '../../Common/Loader/Loader';
import validate from './validate';
import submit from './submit';
import { getCurrencySymbol } from '../../../helpers/currencyConvertion';


class ManageServiceFee extends React.Component {

    constructor(props) {
        super(props)
        this.state = {
            feeType: 'flatFee'
        }
    }

    handleDriverShareChange = (event) => {
        const { change } = this.props;
        let value = Number(event.target.value);
        if (value > 100) {
            value = 100;
        }
        if (!isNaN(value) && value >= 0 && value <= 100) {
            change('bookingFeeDriverShare', value);
            change('bookingFeeCompanyShare', 100 - value);
        } else if (event.target.value === '') {
            change('bookingFeeDriverShare', '');
            change('bookingFeeCompanyShare', '');
        }
    }

    handleCompanyShareChange = (event) => {
        const { change } = this.props;
        let value = Number(event.target.value);
        if (value > 100) {
            value = 100;
        }
        if (!isNaN(value) && value >= 0 && value <= 100) {
            change('bookingFeeCompanyShare', value);
            change('bookingFeeDriverShare', 100 - value);
        } else if (event.target.value === '') {
            change('bookingFeeDriverShare', '');
            change('bookingFeeCompanyShare', '');
        }
    }

    static defaultProps = {
        loading: false
    };

    componentDidMount() {
        const { initialValues } = this.props;
        if (initialValues) {
            this.setState({
                feeType: initialValues.feeType,
            });
            this.props.initialize({
                ...initialValues,
                feeType: initialValues.feeType,
                bookingFeeDriverShare: initialValues.bookingFeeDriverShare != null ? initialValues.bookingFeeDriverShare * 100 : 100,
                bookingFeeCompanyShare: initialValues.bookingFeeCompanyShare != null ? initialValues.bookingFeeCompanyShare * 100 : 0
            });
        } else {
            this.props.initialize({
                feeType: 'flatFee',
                bookingFeeDriverShare: 100,
                bookingFeeCompanyShare: 0
            });
        }
    }

    UNSAFE_componentWillReceiveProps(nextProps) {
        const { initialValues } = nextProps;
        if (initialValues && initialValues !== this.props.initialValues) {
            this.setState({
                feeType: initialValues.feeType,
            });
            // Reset form with new values
            this.props.initialize({
                ...initialValues,
                feeType: initialValues.feeType,
                bookingFeeDriverShare: initialValues.bookingFeeDriverShare != null ? initialValues.bookingFeeDriverShare * 100 : 100,
                bookingFeeCompanyShare: initialValues.bookingFeeCompanyShare != null ? initialValues.bookingFeeCompanyShare * 100 : 0
            });
        }
    }

    shouldComponentUpdate(nextProps, nextState) {
        return (
            nextProps.initialValues !== this.props.initialValues ||
            nextState.feeType !== this.state.feeType
        );
    }

    handleFeeType(e) {
        const feeType = e.target.value;
        this.setState({
            feeType,
        });
        // Update form value when fee type changes
        this.props.change('feeType', feeType);
    }

    renderSelectField = ({
        input, label, type, meta: { touched, error }, labelClass, fieldClass, placeholder, children,
    }) => {
        const { formatMessage } = this.props.intl;
        return (
            <Form.Group className={s.space3}>
                <Form.Label>{label}</Form.Label>
                <Form.Control as="select" {...input} placeholder={placeholder} className={cx(fieldClass, s.formControlInput)}>
                    {children}
                </Form.Control>
                {touched && error && <span className={s.errorMessage}>{formatMessage(error)}</span>}
            </Form.Group>
        );
    }
    
    renderInfoIcon = (title, body) => (
        <OverlayTrigger
            trigger={['hover', 'focus']}
            placement="top"
            overlay={
                <Popover id={`popover-${title}`}>
                    <Popover.Title as="h3">{title}</Popover.Title>
                    <Popover.Content>{body}</Popover.Content>
                </Popover>
            }
        >
            <span className={s.infoIcon}>
                <svg width="15" height="15" viewBox="0 0 24 24" fill="currentColor">
                    <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-6h2v6zm0-8h-2V7h2v2z" />
                </svg>
            </span>
        </OverlayTrigger>
    )

    renderFieldDiscount = ({
        input, label, type, meta: { touched, error }, labelClass, fieldClass, placeholder, isPrice, currency, maxlength, unit, info,
    }) => {
        const { currentLocale } = this.props;
        const { formatMessage } = this.props.intl;
        return (
            <div className={cx('inputFormAddon', 'addonBorder')}>
                <Form.Group className={s.space3}>
                    <Form.Label className={cx(info && s.labelWithInfo)}>
                        {label}
                        {info && this.renderInfoIcon(info.title, info.body)}
                    </Form.Label>
                    <InputGroup>
                        {
                            isPrice == 1 && <InputGroup.Append>
                                <InputGroup.Text>
                                    {
                                        getCurrencySymbol(currency, currentLocale)
                                    }
                                </InputGroup.Text>
                            </InputGroup.Append>
                        }
                        <Form.Control {...input} placeholder={placeholder} type={type} className={cx(fieldClass, s.formControlInput)} maxLength={maxlength} />
                        {
                            isPrice != 1 && <InputGroup.Append>
                                <InputGroup.Text>{unit || '%'}</InputGroup.Text>
                            </InputGroup.Append>
                        }
                    </InputGroup>
                    {touched && error && <span className={s.errorMessage}>{formatMessage(error)}</span>}
                </Form.Group>
            </div>
        );
    }

    render() {
        const { formatMessage } = this.props.intl;
        const {
            handleSubmit, loading, submitting, currency, distanceUnit,
            initialValues
        } = this.props;
        const { feeType } = this.state;
        
        return (
            <div>
                <Container fluid>
                    <form onSubmit={handleSubmit(submit)}>
                        <Row>
                            <Col xl={12} lg={8} md={12} sm={12} xs={12} className={s.blackCenter}>
                                <div className={s.blackCenterSection}>
                                    <Col xs={12} sm={12} md={12} lg={12}>
                                        <Row>
                                            <Col xs={12} sm={12} md={12} lg={6}>
                                                <Field
                                                    name="feeType"
                                                    placeholder={formatMessage(messages.feeType)}
                                                    component={this.renderSelectField}
                                                    label={formatMessage(messages.feeType)}
                                                    labelClass={s.labelText}
                                                    fieldClass={cx(s.formControlSelect)}
                                                    onChange={(e) => this.handleFeeType(e)}
                                                >
                                                    <option value={"flatFee"}>{formatMessage(messages.flatFee)}</option>
                                                    <option value={"distanceBasedFee"}>{formatMessage(messages.distanceBasedFee)}</option>
                                                </Field>
                                            </Col>
                                            <Col xs={12} sm={12} md={12} lg={6} className={'borderRighOnly'}>
                                                <Field
                                                    name="deliveryFee"
                                                    type="text"
                                                    label={feeType == 'distanceBasedFee' ? formatMessage(messages.pickupFee) : formatMessage(messages.deliveryFee)}
                                                    placeholder={0}
                                                    component={this.renderFieldDiscount}
                                                    maxLength={8}
                                                    labelClass={s.labelText}
                                                    className={cx(s.formControlSelect, s.formControlInput)}
                                                    isPrice={1}
                                                    currency={currency}
                                                />
                                            </Col>

                                            {feeType == 'distanceBasedFee' &&
                                                <Col xs={12} sm={12} md={12} lg={6} className={'borderRighOnly'}>
                                                    <Field
                                                        name="dropFee"
                                                        type="text"
                                                        label={formatMessage(messages.dropFee)}
                                                        placeholder={0}
                                                        component={this.renderFieldDiscount}
                                                        maxLength={8}
                                                        labelClass={s.labelText}
                                                        className={cx(s.formControlSelect, s.formControlInput)}
                                                        isPrice={1}
                                                        currency={currency}
                                                    />
                                                </Col>
                                            }
                                            {feeType == 'distanceBasedFee' &&
                                                <Col xs={12} sm={12} md={12} lg={6} className={'borderRighOnly'}>
                                                    <Field
                                                        name="distanceFee"
                                                        type="text"
                                                        label={`${formatMessage(messages.distanceFee)} ${distanceUnit == 'km' ? "(per Km)" : "(per Mile)"}`}
                                                        placeholder={0}
                                                        component={this.renderFieldDiscount}
                                                        maxLength={8}
                                                        labelClass={s.labelText}
                                                        className={cx(s.formControlSelect, s.formControlInput)}
                                                        isPrice={1}
                                                        currency={currency}
                                                    />
                                                </Col>
                                            }

                                            {feeType == 'distanceBasedFee' &&
                                                <Col xs={12} sm={12} md={12} lg={6} className={'borderRighOnly'}>
                                                    <Field
                                                        name="normalDistanceLimitKm"
                                                        type="text"
                                                        label={'Normal Price Distance Limit'}
                                                        placeholder={0}
                                                        component={this.renderFieldDiscount}
                                                        maxLength={4}
                                                        labelClass={s.labelText}
                                                        className={cx(s.formControlSelect, s.formControlInput)}
                                                        isPrice={2}
                                                        unit={distanceUnit == 'km' ? 'Km' : 'Mile'}
                                                        info={{
                                                            title: 'Normal Distance Limit',
                                                            body: `Distance charged at the normal Distance Fee. Beyond this limit, the Extra Distance Fee applies. Leave empty to use one rate for the whole trip.`
                                                        }}
                                                    />
                                                </Col>
                                            }
                                            {feeType == 'distanceBasedFee' &&
                                                <Col xs={12} sm={12} md={12} lg={6} className={'borderRighOnly'}>
                                                    <Field
                                                        name="extraDistanceFee"
                                                        type="text"
                                                        label={`Extra Distance Fee ${distanceUnit == 'km' ? "(per Km)" : "(per Mile)"}`}
                                                        placeholder={0}
                                                        component={this.renderFieldDiscount}
                                                        maxLength={8}
                                                        labelClass={s.labelText}
                                                        className={cx(s.formControlSelect, s.formControlInput)}
                                                        isPrice={1}
                                                        currency={currency}
                                                        info={{
                                                            title: 'Extra Distance Fee',
                                                            body: `Rate for each ${distanceUnit == 'km' ? 'Km' : 'Mile'} beyond the Normal Distance Limit. Example: limit 10, normal 2,500, extra 4,000 — a 20 Km trip costs (10 x 2,500) + (10 x 4,000).`
                                                        }}
                                                    />
                                                </Col>
                                            }

                                            <Col xs={12} sm={12} md={12} lg={6} className='noRadiusLeft'>
                                                <Field
                                                    name="bookingFee"
                                                    type="text"
                                                    label={formatMessage(messages.bookingFee)}
                                                    placeholder={"%"}
                                                    component={this.renderFieldDiscount}
                                                    labelClass={s.labelText}
                                                    className={cx(s.formControlSelect, s.formControlInput)}
                                                    isPrice={2}
                                                    maxLength={3}
                                                />
                                            </Col>
                                           
                                            <Col xs={12} sm={12} md={12} lg={6} className='noRadiusLeft'>
                                                <Field
                                                    name="shopFee"
                                                    type="text"
                                                    label={formatMessage(messages.shopFee)}
                                                    placeholder={"%"}
                                                    component={this.renderFieldDiscount}
                                                    labelClass={s.labelText}
                                                    className={cx(s.formControlSelect, s.formControlInput)}
                                                    isPrice={2}
                                                    maxLength={2}
                                                />
                                            </Col>
                                             <Col xs={12} sm={12} md={12} lg={12} className='noRadiusLeft'>
                                                <Row>
                                                    <Col xs={12} sm={12} md={6} lg={6}>
                                                        <Field
                                                            name="bookingFeeDriverShare"
                                                            type="text"
                                                            label={'Booking Fee Driver Share'}
                                                            placeholder={"%"}
                                                            component={this.renderFieldDiscount}
                                                            labelClass={s.labelText}
                                                            className={cx(s.formControlSelect, s.formControlInput)}
                                                            isPrice={2}
                                                            maxLength={3}
                                                            onChange={this.handleDriverShareChange}
                                                        />
                                                    </Col>
                                                    <Col xs={12} sm={12} md={6} lg={6}>
                                                        <Field
                                                            name="bookingFeeCompanyShare"
                                                            type="text"
                                                            label={'Booking Fee Company Share'}
                                                            placeholder={"%"}
                                                            component={this.renderFieldDiscount}
                                                            labelClass={s.labelText}
                                                            className={cx(s.formControlSelect, s.formControlInput)}
                                                            isPrice={2}
                                                            maxLength={3}
                                                            onChange={this.handleCompanyShareChange}
                                                        />
                                                    </Col>
                                                </Row>
                                            </Col>
                                            <Col xs={12} sm={12} md={12} lg={6} className='noRadiusLeft'>
                                                <Field
                                                    name="driverFee"
                                                    type="text"
                                                    label={formatMessage(messages.driverFee)}
                                                    placeholder={"%"}
                                                    component={this.renderFieldDiscount}
                                                    labelClass={s.labelText}
                                                    className={cx(s.formControlSelect, s.formControlInput)}
                                                    isPrice={2}
                                                    maxLength={2}
                                                />
                                            </Col>

                                        </Row>
                                        
                                    </Col>
                                </div>
                            </Col>
                            <Col xs={12} sm={12} md={12} lg={12} className={cx(s.textAlignRight, s.btnPadding, 'textAlignLeftRTL', 'btnPaddingRTL')}>
                                <FormGroup className={s.noMargin}>
                                    <div>
                                        <Loader
                                            type={"button"}
                                            label={formatMessage(messages.submitButton)}
                                            show={loading}
                                            buttonType={'submit'}
                                            className={cx(s.button, s.btnPrimary)}
                                            disabled={submitting || loading}
                                            isSuffix={true}
                                        />
                                    </div>
                                </FormGroup>
                            </Col>
                        </Row>
                    </form>
                </Container>
            </div>
        )
    }

}

ManageServiceFee = reduxForm({
    form: 'ServiceFeeForm',
    validate,
    onSubmit: submit
})(ManageServiceFee)

const selector = formValueSelector('ServiceFeeForm');

const mapState = state => ({
    feeType: selector(state, 'feeType'),
    currency: state.siteSettings.data.currency,
    distanceUnit: state.siteSettings.data.distanceUnits,
    currentLocale: state.intl.locale,
})

const mapDispatch = {

}

export default injectIntl(withStyles(s)(connect(mapState, mapDispatch)(ManageServiceFee)));